import React, { Suspense, lazy,useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Footer from "./CommenFooterComponent/index";
import Banner from "../components/LOBanner/LOBanner";
import MediaQuery from "react-responsive";
import HeaderNavbar from "../components/HeaderHome";
import LOSECTION from "./LoanOfficersection/LoanOfficer";

import jsonData from "./ai-branding.json"; // Import the JSON

export default function LoanOfficerHome() {
 
  //get name details from url params
  const { loanofficername } = useParams();
  //Make loanofficername lowercase to prevent issues with capital letters in url
  const lowerCaseLoanOfficerName = loanofficername.slice().toLowerCase();
  const [dpaData, setDPAData] = useState();
  const [loanOfficer, setLoanOfficer] = useState();
  const [loanRealtor, setRealtor] = useState();
  const [Contactdata, setContactdata] = useState();
  const [dateTime, setDateTime] = useState(null);

  const [showOtherComponents, setShowOtherComponents] = useState(false);

  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.offsetHeight;

    const scrollPosition =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop;
    const maxScroll = documentHeight - windowHeight;
    const percentage = (scrollPosition / maxScroll) * 100;
    if (percentage > 0) {
      setShowOtherComponents(true);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Clean up the scroll listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once, like componentDidMount
  useEffect(() => {
    const removeListener = () => {
      if (showOtherComponents)
        window.removeEventListener("scroll", handleScroll);
    };
    removeListener();
  }, [showOtherComponents]);

  useEffect(() => {
    const fetchdpaJSON = async () => {
      try {
        const loanOfficerResponse = await axios.get(
          process.env.REACT_APP_CDN_URL +
            "includes/" +
            lowerCaseLoanOfficerName +
            ".json"
        );

        const loanOfficerData = loanOfficerResponse.data;

        // Check if loanOfficer is null or undefined
        // if (!loanOfficerData.Loanofficer) {
        //   window.location.replace("https://www.swmc.com/artofhomebuying/");
        //   return;
        // }

        setLoanOfficer(loanOfficerData.Loanofficer);
        setRealtor(loanOfficerData.RealtorData);
        setContactdata(loanOfficerData.ContactData);
        setDateTime(loanOfficerData.dateandTime);

        const dpaDataResponse = await axios.get(
          process.env.REACT_APP_ARTOFHOMEBUYING_JSON
        );
        setDPAData(dpaDataResponse.data);
      } catch (error) {
        console.error("Error fetching loan officer data:", error);
        window.location.replace("https://www.swmc.com/artofhomebuying/");
        window.location.replace(process.env.PUBLIC_URL);
      }
    };

    fetchdpaJSON();
  }, [lowerCaseLoanOfficerName]);

  const [links, setLinks] = useState(null); // Set initial state as null
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  const sectionRef = useRef(null);

  const scrollToSection = () => {
    const navbarHeight = document.getElementById("navbar").clientHeight; // Adjust 'navbar' with the ID of your navbar
    const sectionTop = sectionRef.current.offsetTop - navbarHeight;
    window.scrollTo({
      top: sectionTop,
      behavior: "smooth",
    });
  };

  if (dpaData) {
    const lobannerData = dpaData.LObanner;
    const WebinarHighlightsData = dpaData.WebinarHighlights;
    const featurenData = dpaData.featuresection;
    const disclaimerData = dpaData.fristresponderdisclaimer;

    return (
      <>
       
          <HeaderNavbar     loanRealtor={loanRealtor}/>
          {lobannerData ? (
            <Banner
              lobannerData={lobannerData}
              loanOfficer={loanOfficer}
              loanRealtor={loanRealtor}
              dateTime={dateTime}
              fetchpriority="high"
            />
          ) : (
            ""
          )}
       
              <Suspense fallback={<div />}>
                <LOSECTION
                  loanOfficer={loanOfficer}
                  loanRealtor={loanRealtor}
                  Contactdata={Contactdata}
                  dateTime={dateTime}
                />
              </Suspense>
              {showOtherComponents && (
            <>
              <Suspense fallback={<div />}>
                <div>
                  <Footer fetchpriority="low" links={links.current} />
                </div>
              </Suspense>
            </>
          )}
      

       
      </>
    );
  } else {
    return <></>;
  }
}
